import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { env } from '../constants/env'
import { Auth } from 'aws-amplify'

const session = async () => await Auth.currentSession()

export const baseAxiosInstance = axios.create({
	baseURL: env.apiBaseUrl,
	headers: {},
})

baseAxiosInstance.interceptors.request.use(async (config) => {
	config.headers.Authorization = (await session()).getIdToken().getJwtToken()
	return config
})

export type RequestStatus = 'Loading' | 'Ready' | 'Error'

export const getPagedData = async (endpoint: string, limit: number, updatePage: (data: unknown, pageStatus: RequestStatus) => void) => {
	let page = 1
	let finished = false
	let status: RequestStatus = 'Loading'
	let result: AxiosResponse<unknown & { resultsLength: number }>

	while (!finished) {
		result = await get(`${endpoint}${endpoint.endsWith('&') ? '' : '?'}page=${page}&pageSize=${limit}`)

		if (!result.data || result.status !== 200) {
			status = 'Error'
			finished = true
		} else {
			page += 1

			if (result.data.resultsLength === 0) {
				status = 'Ready'
				finished = true
			}
		}
		updatePage(result.data, status)
	}
}

// eslint-disable-next-line
export const get = async (endpoint: string, options?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
	return new Promise<AxiosResponse<unknown>>((resolve, reject) => {
		baseAxiosInstance
			.get(endpoint, options)
			.catch((error: AxiosError) => {
				if (error.response && error.response.status === 401) {
					window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname) + window.location.hash
				}
				reject(error)
			})
			.then((value: AxiosResponse<unknown> | void) => {
				// eslint-disable-next-line
				resolve(value as any)
			})
	})
}

export const post = (endpoint: string, body: unknown) => baseAxiosInstance.post(endpoint, body)

export const put = (endpoint: string, body: unknown) => baseAxiosInstance.put(endpoint, body)

export const del = (endpoint: string) => baseAxiosInstance.delete(endpoint)

export const sleep = (length: number) => new Promise((resolve) => setTimeout(() => resolve(undefined), length))
